import axios from "axios";

export default {
	listItems(ctx) {
		return axios.get("/v3/admin/items", {
			params: ctx
		});
	},

	getItem(id) {
		return axios.get(`/v3/item/${id}`);
	},

	getItemWithExemplars(id) {
		return axios.get(`/v3/item+exemplars/${id}`);
	},

	isScored(id) {
		return axios.get(`/v3/admin/item_scored/${id}`);
	},

	saveItem(item) {
		return axios.post("/v3/admin/item", item);
	},

	removeItem(id) {
		return axios.delete(`/v3/admin/item/${id}`);
	},

	copyItem(id) {
		return axios.post(`/v3/admin/item/${id}/copy`);
	},

	simScorePair(item, firstRead, secondRead) {
		let ctx = {
			item: item,
			first_read: firstRead,
			second_read: secondRead,
			compare: firstRead && secondRead ? true : false
		};
		return axios.post("/v3/admin/simscorepair", ctx);
	},

	getItemAssessments(id) {
		return axios.get(`/v3/admin/item/${id}/assessments`);
	},

	regenerateReliability(asmtID) {
		return axios.post(`/v3/reliability/recalc/${asmtID}`);
	}
};



// WEBPACK FOOTER //
// ./src/services/ItemService.js